import script from "./SelectLanguageView.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectLanguageView.vue?vue&type=script&setup=true&lang=js"

import "./SelectLanguageView.vue?vue&type=style&index=0&id=83f50f70&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83f50f70"]])

export default __exports__